import { useReveal } from "./components/site/useReveal";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { TrustRow } from "./components/site/TrustRow";
import { Services } from "./components/site/Services";
import { Projects } from "./components/site/Projects";
import { About } from "./components/site/About";
import { Process } from "./components/site/Process";
import { Area } from "./components/site/Area";
import { SocialProof } from "./components/site/SocialProof";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";

function App() {
  useReveal();
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-ink focus:px-4 focus:py-2 focus:text-paper"
        data-testid="skip-link"
      >
        Hoppa till innehållet
      </a>
      {"\n"}
      <Header />
      {"\n"}
      <main id="main">
        {"\n  "}
        <Hero />
        {"\n  "}
        <TrustRow />
        {"\n  "}
        <Services />
        {"\n  "}
        <Projects />
        {"\n  "}
        <About />
        {"\n  "}
        <Process />
        {"\n  "}
        <Area />
        {"\n  "}
        <SocialProof />
        {"\n  "}
        <Contact />
        {"\n"}
      </main>
      {"\n"}
      <Footer />
    </>
  );
}

export default App;
